import { AcceptReportTrackers } from '@olxeu-a2b/ui/typings/safeDealTracking';
import trackingKeys from '../../tracking/trackingKeys';
import useSafeDealEventTracking from './useSafeDealEventTracking';
import useSafeDealLinkEventTracking from './useSafeDealLinkEventTracking';

const {
  deliverySafeDealReportFormSuccessShow,
  deliverySafeDealReportFormGoToMyDelivClick,
  deliverySafeDealReportSuccessChatButtonClick,
  deliverySafeDealReportSuccessChatButtonShown,
} = trackingKeys.events;

const useSafeDealAcceptReportTracking = (adId: string): AcceptReportTrackers => {
  const trackReportFormSuccessShow = useSafeDealEventTracking(
    deliverySafeDealReportFormSuccessShow,
    adId,
  );

  const trackReportFormGoToMyDelivClick = useSafeDealLinkEventTracking(
    deliverySafeDealReportFormGoToMyDelivClick,
    adId,
  );

  const trackReportSuccessPageButtonClick = useSafeDealLinkEventTracking(
    deliverySafeDealReportSuccessChatButtonClick,
    adId,
    deliverySafeDealReportFormSuccessShow,
  );

  const trackReportSuccessPageButtonShown = useSafeDealEventTracking(
    deliverySafeDealReportSuccessChatButtonShown,
    adId,
    deliverySafeDealReportFormSuccessShow,
  );

  return {
    trackReportFormSuccessShow,
    trackReportFormGoToMyDelivClick,
    trackReportSuccessPageButtonClick,
    trackReportSuccessPageButtonShown,
  };
};

export default useSafeDealAcceptReportTracking;
